import { render, staticRenderFns } from "./Self_assessment_signup.vue?vue&type=template&id=79d6fc9a&"
import script from "./Self_assessment_signup.vue?vue&type=script&lang=js&"
export * from "./Self_assessment_signup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports